import React from "react";
import gif from "../assets/img/Four_O_Four.gif";

const NotFound = () => {
  return (
    <div
      className="not-found "
      style={{
        overflow: "hidden",
        display: "block",
        margin: "0 auto",
        width: "50%",
      }}
    >
      <img src={gif} alt="404" style={{ height: "55.9vh", width: "40vw" }} />
    </div>
  );
};

export default NotFound;
